import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import { errorLogger } from '@utils/errorLogger.util.js';
import { fetchTickets } from '../lib/api/fetchTickets';

export const useUserTicketsSummationStore = create((set) => ({
  loading: true,
  error: null,
  isSurveyDone: false,
  totalSum: 0,
  tickets: [],
  ticketsCount: 0,

  getTickets: async (chat_id) => {
    set({ error: null, loading: true, success: false });

    try {
      const { success, message, user_checks, total_sum, survey, tickets_num } =
        await fetchTickets(chat_id);

      if (!success) {
        set({ error: message });
        return;
      }

      set({
        error: null,
        isSurveyDone: survey ?? false,
        totalSum: total_sum ?? 0,
        tickets: user_checks ?? [],
        ticketsCount: tickets_num ?? 0,
      });
    } catch (error) {
      errorLogger.error(error, { source: useUserTicketsSummationStore.name });
      set({ error: 'Error. Please try to reload this page.' });
    } finally {
      set({ loading: false });
    }
  },
}));

export const useUserTicketsSummationData = () => {
  return useUserTicketsSummationStore(
    useShallow((state) => ({
      getTickets: state.getTickets,
      isTicketsLoading: state.loading,
      userTicketsError: state.error,
      isSurveyDone: state.isSurveyDone,
      tickets: state.tickets,
      ticketsCount: state.ticketsCount,
      totalSum: state.totalSum,
    })),
  );
};
